import React from 'react';
import Swiper from './Swiper';

const MaybeSwiper = ({ children, classNames, ...rest }) => {
  if (React.Children.count(children) > 1) {
    return (
      <Swiper classNames={classNames} {...rest}>
        {children}
      </Swiper>
    );
  }
  return (
    <div className={classNames.wrapper}>
      {children}
    </div>
  );
};

MaybeSwiper.propTypes = Swiper.propTypes;
MaybeSwiper.defaultProps = Swiper.defaultProps;

export default MaybeSwiper;
